export default "__VITE_ASSET__b7f7feeb__"